import { useEffect } from "react";

const usePreventBrowserBack = (enabled) => {
  useEffect(() => {
    if (!enabled) return undefined;

    const currentUrl = window.location.href;
    const state = { preventBrowserBack: true };

    window.history.pushState(state, "", currentUrl);

    const handlePopState = () => {
      window.history.pushState(state, "", currentUrl);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [enabled]);
};

export default usePreventBrowserBack;
